import { Component } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-xsell-consent-unavailable-dialog',
  styleUrls: ['./xsell-consent-unavailable-dialog.component.scss'],
  templateUrl: './xsell-consent-unavailable-dialog.component.html',
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatDialogClose,
    MatButton,
  ],
})
export class XsellConsentUnavailableDialogComponent {
  constructor() {}
}
